import React from 'react';

const SOCIAL_LINKS = [
    { key: 'website', icon: 'fa-globe', label: 'Website' },
    { key: 'instagram', icon: 'fa-instagram', label: 'Instagram' },
    { key: 'facebook', icon: 'fa-facebook', label: 'Facebook' },
    { key: 'twitter', icon: 'fa-twitter', label: 'X / Twitter' },
    { key: 'linkedin', icon: 'fa-linkedin', label: 'LinkedIn' },
    { key: 'youtube', icon: 'fa-youtube-play', label: 'YouTube' }
];

const clean = (value) => (typeof value === 'string' ? value.trim() : '');

const normalizeUrl = (value) => {
    const cleaned = clean(value);
    if (!cleaned) return '';
    if (/^https?:\/\//i.test(cleaned)) return cleaned;
    return `https://${cleaned}`;
};

const BusinessBranding = ({ business }) => {
    if (!business) return null;

    const studioName = clean(business.studio_name);
    const tagline = clean(business.tagline);
    const phone = clean(business.phone);
    const email = clean(business.email);
    const logoUrl = clean(business.logo_url);

    const socialItems = SOCIAL_LINKS
        .map((item) => ({
            ...item,
            href: normalizeUrl(business[item.key])
        }))
        .filter((item) => item.href);

    const hasBrandingData = studioName || tagline || phone || email || logoUrl || socialItems.length > 0;
    if (!hasBrandingData) return null;

    return (
        <div className="business-branding">
            {(logoUrl || studioName || tagline) && (
                <div className="business-branding-header">
                    {logoUrl && (
                        <img
                            src={logoUrl}
                            alt={studioName || 'Business logo'}
                            className="business-branding-logo"
                        />
                    )}
                    <div className="business-branding-text">
                        {studioName && <h4 className="business-branding-name">{studioName}</h4>}
                        {tagline && <p className="business-branding-tagline">{tagline}</p>}
                    </div>
                </div>
            )}

            {(phone || email) && (
                <div className="business-contact-list">
                    {phone && (
                        <a href={`tel:${phone.replace(/\s+/g, '')}`} className="business-contact-item">
                            <i className="fa fa-phone"></i>
                            <span>{phone}</span>
                        </a>
                    )}
                    {email && (
                        <a href={`mailto:${email}`} className="business-contact-item">
                            <i className="fa fa-envelope"></i>
                            <span>{email}</span>
                        </a>
                    )}
                </div>
            )}

            {socialItems.length > 0 && (
                <div className="business-social-links">
                    {socialItems.map((item) => (
                        <a
                            key={item.key}
                            href={item.href}
                            target="_blank"
                            rel="noreferrer"
                            className="social-link-icon"
                            aria-label={item.label}
                            title={item.label}
                        >
                            <i className={`fa ${item.icon}`}></i>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
};

export default BusinessBranding;
